import { IonBadge, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonInput, IonItem, IonItemDivider, IonLabel, IonList, IonListHeader, IonModal, IonPage, IonPopover, IonRadio, IonRadioGroup, IonRow, IonSelect, IonSelectOption, IonText, IonTitle, IonToolbar, withIonLifeCycle } from "@ionic/react";
import { arrowBack, barChartOutline, clipboardOutline } from "ionicons/icons";
import moment from "moment";
import React from "react";
import { Chart } from "react-google-charts";
import AcrofitHeader from "../components/AcrofitHeader";
import { HideLoader, ShowLoader, ShowToast } from "../components/Alerts";
import { Authentication } from "../components/Authentication";
import db from "../components/Database";
import { sync_calorias_dia } from "../components/Funciones";
import { IValorImc, PanelResumen, tabla_imc } from "../components/ResumenIMC";
import icon_peso from "../images/icon_peso.svg";
import IActividadFisica from "../interfaces/IActividadFisica";
import ICaloriasDia from "../interfaces/ICaloriasDia";
import IDatosIniciales from "../interfaces/IDatosIniciales";
import IPesoSemanal from "../interfaces/IPesoSemanal";
import IUsuario from "../interfaces/IUsuario";
import { get, post } from "../Rest";

class HomePage extends React.Component{

    graficosPesos = null as GraficoPesos | null
    graficosCalorias = null as GraficoCalorias | null

    state = {
        datos_iniciales:{} as IDatosIniciales,
        usuario:{} as IUsuario,
        imc:0 as number,
        valor_imc:{} as IValorImc,
        dias:0 as number,
        peso_semanal:{} as IPesoSemanal,
        peso:0 as number,
        mounted:false
    }

    ionViewDidEnter(){
        this.init()
    }

    init = async () => {
        if(window.navigator.onLine){
            const cat_actividades_fisicas = await get("actividades_fisicas")
            await db.cat_actividades_fisicas.bulkPut(cat_actividades_fisicas)
        }
        const datos_iniciales = await db.datos_iniciales.toArray()
        const usuarios = await db.usuarios.toArray()
        await sync_calorias_dia(datos_iniciales[0])
        if(usuarios.length > 0){
          const usuario = usuarios[0]
          const pesos_semanales = await db.pesos_semanales.toArray()
          const pesos_semanales_sort = pesos_semanales.sort((a,b) => -moment(a.fecha_registro).diff(b.fecha_registro,"day"))
          const imc = parseFloat(pesos_semanales_sort[0].peso)*10000/(parseFloat(usuario.altura)*parseFloat(usuario.altura))
          const valor_imc = tabla_imc[usuario.genero].find(c => c.min<=imc && c.max>imc)
          const dias = moment().diff(moment(datos_iniciales[0].fecha_registro).startOf('day'),"days")
          await this.setState({datos_iniciales:datos_iniciales[0],usuario,imc,valor_imc,dias,peso_semanal:pesos_semanales_sort[0],peso:pesos_semanales_sort[0].peso,mounted:true})
        }else{
          await Authentication.logout()
        }
    }

    refresh = async () => {
        const pesos_semanales = await db.pesos_semanales.toArray()
        const calorias_dia = await db.calorias_dia.toArray()
        this.setState({pesos_semanales,calorias_dia})
    }

    render(){
        const {usuario,imc,valor_imc,peso_semanal,datos_iniciales,dias,mounted} = this.state
        return (
            <IonPage>
                <AcrofitHeader />
                {
                    mounted && (
                        <IonContent className="no-bg">
                            <PanelResumen genero={usuario.genero} imc={imc} valor_imc={valor_imc} className="no-bg" />
                            <IonCard className="transparent">
                                <IonCardHeader>
                                    <IonCardTitle className="ion-text-center"><IonIcon icon={clipboardOutline} /> Peso</IonCardTitle>
                                    <IonCardSubtitle className="ion-text-center">Datos registrados desde tu última medición</IonCardSubtitle>
                                </IonCardHeader>
                                <IonCardContent>
                                    <IonGrid>
                                        <IonRow>
                                            <IonCol size="4">
                                                <IonItem lines="none" color="primary">
                                                    <div style={{textAlign:"center",width:"100%"}}>
                                                        <small><b>Inicial</b></small><br/>
                                                        <b>{datos_iniciales.peso+"kg"}</b>
                                                    </div>
                                                </IonItem>                                    
                                            </IonCol>
                                            <IonCol size="4">
                                                <IonItem lines="none" color={valor_imc.variant}>
                                                    <div style={{textAlign:"center",width:"100%"}}>
                                                        <small><b>Actual</b></small><br/>
                                                    <b>{peso_semanal?peso_semanal.peso+"kg":""}</b>
                                                    </div>
                                                </IonItem>                                    
                                            </IonCol>
                                            <IonCol size="4">
                                                <IonItem lines="none" color="success">
                                                    <div style={{textAlign:"center",width:"100%"}}>
                                                        <small><b>Meta</b></small><br/>
                                                    <b>{datos_iniciales.peso_objetivo+"kg"}</b>
                                                    </div>
                                                </IonItem>                                    
                                            </IonCol>
                                        </IonRow>
                                    </IonGrid>
                                    <IonCardSubtitle className="ion-text-center">
                                        Han pasado <b>{dias+1}</b> día{dias>1?"s":""} desde que iniciaste tu último plan
                                    </IonCardSubtitle>
                                    <ActualizarPeso onComplete={this.init} datos_iniciales={datos_iniciales} peso_semanal={peso_semanal} />
                                </IonCardContent>
                            </IonCard>
                            <IonCard className="transparent">
                                <IonCardHeader>
                                    <IonCardTitle className="ion-text-center"><IonIcon icon={barChartOutline} /> Calorías</IonCardTitle>
                                    <IonCardSubtitle className="ion-text-center">Presenta la información de las calorías consumidas diariamente</IonCardSubtitle>
                                </IonCardHeader>
                                <IonCardContent>
                                    <GraficoCalorias ref={c => { this.graficosCalorias = c}} datos_iniciales={datos_iniciales} />
                                    <IonButton onClick={this.graficosCalorias?.updateChart} fill="clear" expand="full">Actualizar</IonButton>
                                </IonCardContent>
                            </IonCard>
                            <IonCard className="transparent">
                                <IonCardHeader>
                                    <IonCardTitle className="ion-text-center"><IonIcon icon={barChartOutline} /> Pesos</IonCardTitle>
                                    <IonCardSubtitle className="ion-text-center">Presenta la información de los pesos registrados semanalmente</IonCardSubtitle>
                                </IonCardHeader>
                                <IonCardContent>
                                    <GraficoPesos ref={c => { this.graficosPesos = c}} datos_iniciales={datos_iniciales} />
                                    <IonButton onClick={this.graficosPesos?.updateChart} fill="clear" expand="full">Actualizar</IonButton>
                                </IonCardContent>
                            </IonCard>
                            <ReiniciarPlan datos_iniciales={datos_iniciales} usuario={usuario} peso_semanal={peso_semanal} refresh={this.init} />
                        </IonContent>
                    )
                }
            </IonPage>
        )
    }
}

export default withIonLifeCycle(HomePage);

class GraficoCalorias extends React.Component<{datos_iniciales:IDatosIniciales}> {

    state = {
        items:[] as Array<any>
    }

    updateChart = async () => {
        const calorias_dia = await db.calorias_dia.toArray()
        const {datos_iniciales} = this.props
        const items = [["Fecha","Calorias consumidas","Límite"]]
        const pre_items = {} as any
        for(let i = 0; i<calorias_dia.length; i++){
            if(pre_items[calorias_dia[i].fecha]){
                pre_items[calorias_dia[i].fecha] += parseInt(calorias_dia[i].calorias)
            }else{
                pre_items[calorias_dia[i].fecha] = parseInt(calorias_dia[i].calorias)
            }
        }
        let cont = 0;
        for(let i in pre_items){
            if(cont > 7){
                break;
            }
            items.push([i,pre_items[i],parseInt(datos_iniciales.calorias_dia)])
            cont++;
        }
        await this.setState({items,show:true})
    }

    componentDidMount(){
        this.updateChart()   
    }

    render(){
        const {items} = this.state
        return (
                items.length > 1 ? 
                (
                    <Chart 
                        width="100%"
                        height={300}
                        chartType="ComboChart"
                        loader={<div>Cargando datos...</div>}
                        data={items}
                        options={{
                        title: '',
                        chartArea: { width: '80%', height: '80%' },
                        legend: { position: 'bottom', maxLines: 2 },
                        vAxis: {
                            title: 'Calorías consumidas',
                            minValue: 0,
                        },
                        seriesType: 'bars',
                        series: [{ type: 'bar' },{ type: 'area' }]
                        }}
                        legendToggle />
                ):(
                    <IonBadge>No existen registros suficientes</IonBadge>
                )
        )
    }
}

class GraficoPesos extends React.Component<{datos_iniciales:IDatosIniciales}> {

    state = {
        items:[] as Array<any>
    }

    componentDidMount(){
       this.updateChart()
    }

    updateChart = async () => {
        const pesos_semanales = await db.pesos_semanales.toArray()
        const {datos_iniciales} = this.props
        const items = [["Fecha","Peso","Objetivo"]]
        const pre_items = {} as any
        pesos_semanales.forEach((cal,i) => {
          if(pre_items[cal.fecha_registro]){
            pre_items[cal.fecha_registro] += parseFloat(cal.peso)
          }else{
            pre_items[cal.fecha_registro] = parseFloat(cal.peso)
          }
        })
        let cont = 0;
        for(let i in pre_items){
            if(cont > 7){
                break;
            }
            items.push([i,pre_items[i],parseInt(datos_iniciales.peso_objetivo)])
            cont++;
        }
        await this.setState({items})
    }

    render(){
        const {items} = this.state
        return (
                items.length > 1 ? 
                (
                    <Chart 
                        width="100%"
                        height={300}
                        chartType="ComboChart"
                        loader={<div>Cargando datos...</div>}
                        data={items}
                        options={{
                        title: '',
                        chartArea: { width: '80%', height: '80%' },
                        legend: { position: 'bottom', maxLines: 2 },
                        vAxis: {
                            title: 'Calorías consumidas',
                            minValue: 0,
                        },
                        seriesType: 'bars',
                        series: [{ type: 'bar' },{ type: 'area' }]
                        }}
                        legendToggle />
                ):(
                    <IonBadge>No existen registros suficientes</IonBadge>
                )
        )
    }
}

class ActualizarPeso extends React.Component<{datos_iniciales:IDatosIniciales,onComplete:any,peso_semanal:IPesoSemanal}>{

    state = {
        show:false,
        event:null as any,
        peso:0
    }

    componentDidMount(){
        const {peso_semanal} = this.props
        this.setState({peso:peso_semanal.peso})
    }

    onChange = (e:any) => {
        this.setState({peso:e.detail.value})
    }

    onSavePeso = async (e:any) => {
      e.preventDefault()
      const {datos_iniciales,onComplete} = this.props
      const data = {
        peso: this.state.peso+"",
        datos_iniciales:datos_iniciales.id,
        fecha_registro:moment().format("YYYY-MM-DD")
      } as IPesoSemanal
      const response = await post("peso_semanal",data)
      if(response.respuesta){
        await db.pesos_semanales.put(data)
        await this.setState({peso_semanal:data})
        ShowToast("Peso agregado correctamente","Cambio de peso","success")
        onComplete()
      }else{
        ShowToast("Ya existe un peso registrado el día de hoy","Cambio de peso","danger")
      }
    }

    render(){
        const {show,event,peso} = this.state
        return (
            <>
                <IonButton onClick={(e) => this.setState({show:true,event:e})} color="tertiary" expand="block">Actualizar Peso</IonButton>
                <IonPopover isOpen={show} event={event} onDidDismiss={() => this.setState({show:false})}>
                    <IonContent>
                        <IonItem>
                            <IonLabel>Peso (kg):</IonLabel>
                            <IonInput className="ion-text-right" type="number" step="0.1" max="500" name="peso" value={peso} onIonChange={this.onChange} required />
                        </IonItem>
                        <IonButton onClick={this.onSavePeso}>Actualizar</IonButton>
                    </IonContent>
                </IonPopover>
            </>
        )
    }
}

class ReiniciarPlan extends React.Component<{datos_iniciales:IDatosIniciales,usuario:IUsuario,peso_semanal:IPesoSemanal,refresh:any}>{
    
    state={
        show:false,
        newData:{} as IDatosIniciales,
        cat_actividades_fisicas:[] as Array<IActividadFisica>,
        plan:undefined as number|undefined,
        tmb:undefined as number|undefined,
        peso_ideal:undefined as number|undefined
    }

    onChangeIniciales = (e:any) =>{
        this.setState({newData:{...this.state.newData,[e.target.name]:e.detail.value}})
    }

    async componentDidMount(){
        const {datos_iniciales,peso_semanal} = this.props
        const cat_actividades_fisicas = await db.cat_actividades_fisicas.toArray()
        this.setState({cat_actividades_fisicas,newData:{...datos_iniciales,peso:peso_semanal.peso}})
    }

    reiniciar = async () => {
        const {newData,plan,tmb,peso_ideal} = this.state
        const di = this.props.datos_iniciales

        if(plan!==undefined && tmb!==undefined && peso_ideal!==undefined){
            newData.calorias_dia = (tmb+plan).toFixed(0)
            newData.peso_objetivo = plan === 0 ? di.peso : peso_ideal.toFixed(0)
            newData.kilos_semanales = Math.abs(plan/1000).toFixed(1)
            newData.id = ""
            newData.fecha_registro = moment().format()

            await ShowLoader()
            const {datos_iniciales,pesos_semanales} = await post("reiniciar_plan",newData)
            HideLoader()
            if(datos_iniciales){
                await db.datos_iniciales.clear()
                await db.pesos_semanales.clear()
                await db.calorias_dia.clear()
                await db.datos_iniciales.put(datos_iniciales)
                await db.pesos_semanales.put(pesos_semanales)
                ShowToast("Plan reiniciado correctamente","Reinicio de plan","success")
                await this.props.refresh()
                await this.setState({show:false})
            }else{
                ShowToast("Ha ocurrido un error al reiniciar su plan","Reinicio de plan","danger")
            }
        }else{
            ShowToast("Debe seleccionar un plan para continuar","Reinicio de plan","warning")
        }
    }

    onChangePlan = (plan:number,tmb:number,peso_ideal:number) => {
        this.setState({plan,tmb,peso_ideal})
    }

    render(){
        const {datos_iniciales,usuario,peso_semanal} = this.props
        const {show,newData,plan,cat_actividades_fisicas} = this.state
        const {actividad_fisica} = newData.actividad_fisica?newData:datos_iniciales
        const {genero,altura,fecha_nacimiento} = usuario
        const {peso} = newData.peso?newData:peso_semanal
        const valor = parseFloat(cat_actividades_fisicas.find(ac => ac.id === actividad_fisica)?.valor || "0")
        const edad = -moment(fecha_nacimiento).diff(moment(),"years")

        const tasa_peso = genero==="M"?13.5:9.6
        const tasa_edad = genero==="M"?6.75:4.7
        const tasa_altura = genero==="M"?5:1.8
        const tasa_base = genero==="M"?66:655
        const tmb = (tasa_base + (tasa_peso*parseFloat(peso)) - (tasa_edad*edad) + (tasa_altura*parseFloat(altura)))*valor
        const imc = parseFloat(peso)*10000/(parseFloat(altura)*parseFloat(altura))

        //Formula de Lorentz
        const peso_ideal = parseFloat(altura) - 100 - ((parseFloat(altura)-150)/(genero==="M"?4:2.5))

        return (
            <>
                <IonButton onClick={() => this.setState({show:true})} color="danger" expand="block">Reiniciar plan</IonButton>
                <IonModal isOpen={show} onDidDismiss={() => this.setState({show:false})}>
                    <IonHeader mode="md">
                        <IonToolbar>
                            <IonButtons slot="start">
                                <IonButton onClick={() => this.setState({show:false})} ><IonIcon icon={arrowBack} /></IonButton>
                            </IonButtons>
                            <IonTitle>
                                <IonIcon icon={icon_peso} /> Reiniciar Plan
                            </IonTitle>
                        </IonToolbar>
                    </IonHeader>
                    <IonContent>
                        <IonList>
                            <IonItem>
                                <IonLabel>Peso (kg):</IonLabel>
                                <IonInput className="ion-text-right" type="number" step="0.1" max="500" name="peso" value={newData.peso} onIonChange={this.onChangeIniciales} required />
                            </IonItem>
                            <IonItem>
                                <IonLabel>Altura (cm):</IonLabel>
                                <IonInput className="ion-text-right" value={altura} disabled />
                            </IonItem>
                            <IonItem>
                                <IonLabel>Actividad Física:</IonLabel>
                                <IonSelect name="actividad_fisica" value={newData.actividad_fisica} onIonChange={this.onChangeIniciales} cancelText="Cancelar" >
                                {
                                    cat_actividades_fisicas.map((af,i) => (
                                        <IonSelectOption value={af.id} key={i}>{af.nombre}</IonSelectOption>
                                    ))
                                }
                                </IonSelect>
                            </IonItem>
                            <IonItemDivider></IonItemDivider>
                            <IonListHeader>Plan:</IonListHeader>
                            <IonRadioGroup value={plan} onIonChange={ e => this.onChangePlan(e.detail.value,tmb,peso_ideal)}>
                            <IonItem lines="full">
                                <IonRadio slot="start" value={-1000} />
                                <IonLabel>Bajar 1kg semanal</IonLabel>
                            </IonItem>
                            <IonItem lines="full">
                                <IonRadio slot="start" value={-500} />
                                <IonLabel>Bajar 1/2kg semanal</IonLabel>
                            </IonItem>
                            <IonItem lines="full">
                                <IonRadio slot="start" value={0} />
                                <IonLabel>Mantener peso</IonLabel>
                            </IonItem>
                            <IonItem lines="full">
                                <IonRadio slot="start" value={500} />
                                <IonLabel>Subir 1/2kg semanal</IonLabel>
                            </IonItem>
                            <IonItem lines="full">
                                <IonRadio slot="start" value={1000} />
                                <IonLabel>Subir 1kg semanal</IonLabel>
                            </IonItem>
                            </IonRadioGroup>
                            <IonItem lines="none">
                                <IonText color="danger" style={{textAlign:"center"}}>Una vez reiniciado el plan, se eliminará los datos actuales y reiniciará todo lo avanzado</IonText>
                            </IonItem>
                            <IonButton onClick={this.reiniciar} color="danger" expand="block">Aceptar y reiniciar</IonButton>
                            <IonButton onClick={Authentication.logout} color="danger" fill="clear" expand="full">Cerrar sesión</IonButton>
                        </IonList>
                    </IonContent>
                </IonModal>
            </>
        )
    }
}